import React from 'react';
import Player from '../player/Player.js'

function Footer() {
  return (
    <footer>
      {/* <small>env: { process.env.NODE_ENV }</small> */}
      <Player />
    </footer>
  );
}

export default Footer;
